import React, { FC } from 'react'

// MUI
import { Box, Container, Grid } from '@mui/material'

// UI
import { PaddTwentyFour } from '@/ui'
import { AddressP, AskUsAnythingH2, HeadOfficeH2, LoveToHearP } from './styles'

// Form
import ContactFormSection from './form'

const ContactUsSection: FC = () => {
  return (
    <Box sx={{ py: theme => theme.typography.pxToRem(70) }}>
      <Container maxWidth="xl">
        <PaddTwentyFour>
          <Grid container justifyContent="space-between" spacing={4}>
            <Grid item xs={12} sm={6} md={4}>
              <AskUsAnythingH2>ask us anything</AskUsAnythingH2>

              <LoveToHearP>We&apos;d love to hear from you! Give us call, send us a message ? or find us on social media.</LoveToHearP>
            </Grid>
            <Grid item xs={12} sm={6} md={4} />
            <Grid item xs={12} sm={6} md={4}>
              <HeadOfficeH2>head office</HeadOfficeH2>

              <AddressP>
                Bhaveshvar Nagar, <br /> Behind Ajani Tower Building, <br /> Bhuj - Kachchh, Gujarat - 370 001
              </AddressP>
            </Grid>
          </Grid>

          <ContactFormSection />
        </PaddTwentyFour>
      </Container>
    </Box>
  )
}

export default ContactUsSection
